import { Link } from "react-router-dom";
import { GlassCard } from "@/components/common/GlassCard";
import type { DashboardTile as DashboardTileDef } from "@/lib/dashboard";
import { cn } from "@/lib/utils";

interface DashboardTileProps {
  tile: DashboardTileDef;
  className?: string;
  stacked?: boolean;
}

export function DashboardTile({ tile, className, stacked }: DashboardTileProps) {
  const Icon = tile.icon;

  return (
    <Link to={tile.to} className={cn("block h-full min-w-0", className)}>
      <GlassCard
        className={cn(
          "flex h-full cursor-pointer flex-col transition-all hover:border-violet-400/40 hover:bg-white/5 dark:hover:bg-white/5",
          stacked
            ? "min-h-[7.5rem] p-4 lg:min-h-[10rem] lg:p-5"
            : "min-h-[7.5rem] p-4 lg:min-h-[9rem] lg:p-5"
        )}
      >
        <div className="mb-3 flex items-start justify-between gap-3">
          <div className="rounded-lg bg-indigo-500/20 p-2 text-violet-600 dark:text-violet-300 lg:p-2.5">
            <Icon className="h-4 w-4 lg:h-5 lg:w-5" strokeWidth={1.75} />
          </div>
        </div>
        <h3 className="text-sm font-semibold text-[var(--lm-foreground-strong)] dark:text-white lg:text-base">
          {tile.title}
        </h3>
        <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-[var(--lm-muted)] dark:text-slate-400 lg:text-sm">
          {tile.subtitle}
        </p>
      </GlassCard>
    </Link>
  );
}
